import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/prototypes/")({
  component: PrototypesIndex,
});

function PrototypesIndex() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-20">
      <div className="flex w-full max-w-xl flex-col items-center gap-8 text-center">
        <h1 className="text-4xl font-semibold tracking-tight">Prototypes</h1>
        <p className="text-muted-foreground">
          Experimental features and UI explorations. Nothing here is
          production-ready.
        </p>
        <ul className="w-full space-y-2 text-left">
          <li>
            <Link
              to="/prototypes/agent-first"
              search={{ task: undefined }}
              className="text-primary underline"
            >
              Bear Agent Workspace
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              Agents, tasks, and coordinated changes across your tools
            </span>
          </li>
          <li>
            <Link
              to="/prototypes/manager"
              search={{ view: "returns", sop: undefined }}
              className="text-primary underline"
            >
              Bear Returns
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              For managers: what agents return, and the firm SOPs and checks
              that shape them
            </span>
          </li>
          <li>
            <Link to="/prototypes/evolution" className="text-primary underline">
              Bear Evolution
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              From connected workflows to a shared source of truth
            </span>
          </li>
          <li>
            <Link to="/prototypes/quote" className="text-primary underline">
              Quote Microsite
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              Interactive estimate explorer for owners
            </span>
          </li>
          <li>
            <Link
              to="/prototypes/pricing"
              search={{ q: "", status: undefined, match: undefined }}
              className="text-primary underline"
            >
              Pricing Workbench
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              BOM pricing with inventory matching for GCs
            </span>
          </li>
          <li>
            <Link
              to="/prototypes/clash-meeting"
              className="text-primary underline"
            >
              Clash Coordination Meeting
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              Structured clash walkthrough for coordination meetings
            </span>
          </li>
          <li>
            <Link
              to="/prototypes/understudy"
              className="text-primary underline"
            >
              Understudy
            </Link>
            <span className="ml-2 text-sm text-muted-foreground">
              Revizto simulator and traffic journal for the sync demo
            </span>
          </li>
        </ul>
        <Link to="/" className="text-sm text-muted-foreground underline">
          Back to home
        </Link>
      </div>
    </div>
  );
}
